// npm i -S react-signature-canvas
// https://github.com/szimek/signature_pad
import React, { useState, useEffect, useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';

import Button from '../../../../Components/UI/Button/Button';
import styles from './ConsentForm.module.css';

const isMobile = () =>
  typeof window !== 'undefined' && window.matchMedia('(max-width: 600px)').matches;

const Signature = (props) => {
  const sigPad = useRef(null);
  const mobileSigPad = useRef(null);
  const canvasWrapperRef = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [canvasSize, setCanvasSize] = useState(null);
  const mobile = isMobile();

  // Restore existing signature into desktop canvas on mount
  useEffect(() => {
    if (!mobile && props.value && sigPad.current) {
      sigPad.current.fromDataURL('data:image/svg+xml;base64,' + props.value);
    }
  }, []);

  // When modal opens: measure wrapper, then restore existing signature
  useEffect(() => {
    if (!modalOpen) return;
    requestAnimationFrame(() => {
      if (canvasWrapperRef.current) {
        setCanvasSize({
          width: canvasWrapperRef.current.offsetWidth,
          height: canvasWrapperRef.current.offsetHeight,
        });
      }
    });
  }, [modalOpen]);

  // Restore signature once canvas size is known and canvas is rendered
  useEffect(() => {
    if (canvasSize && props.value && mobileSigPad.current) {
      mobileSigPad.current.fromDataURL('data:image/svg+xml;base64,' + props.value);
    }
  }, [canvasSize]);

  const strokeEndHandler = () => {
    if (sigPad.current) {
      const data = sigPad.current.toDataURL('image/svg+xml').replace('data:image/svg+xml;base64,', '');
      props.onChange(data);
    }
  };

  const clearHandler = () => {
    if (sigPad.current) sigPad.current.clear();
    props.onChange('');
  };

  const mobileDoneHandler = () => {
    if (mobileSigPad.current && !mobileSigPad.current.isEmpty()) {
      const data = mobileSigPad.current.toDataURL('image/svg+xml').replace('data:image/svg+xml;base64,', '');
      props.onChange(data);
    }
    setModalOpen(false);
    setCanvasSize(null);
  };

  const mobileClearHandler = () => {
    if (mobileSigPad.current) mobileSigPad.current.clear();
  };

  const openModal = () => { setCanvasSize(null); setModalOpen(true); };
  const closeModal = () => { setModalOpen(false); setCanvasSize(null); };

  if (mobile) {
    return <>
      {props.value
        ? <div className={styles.sigPreview}>
            <i className="fas fa-check-circle" /> Unterschrift vorhanden
            <Button onClick={openModal}>Ändern</Button>
          </div>
        : <Button onClick={openModal}>
            <i className="fas fa-pen" /> Unterschreiben
          </Button>
      }
      {modalOpen && (
        <div className={styles.sigModal}>
          <div className={styles.sigModalCanvasWrapper} ref={canvasWrapperRef}>
            {canvasSize && (
              <SignatureCanvas
                penColor='blue'
                canvasProps={{
                  width: canvasSize.width,
                  height: canvasSize.height,
                  className: styles.sigModalCanvas,
                }}
                ref={mobileSigPad}
              />
            )}
          </div>
          <div className={styles.sigModalControls}>
            <Button onClick={mobileClearHandler}><i className="fas fa-trash" /> Löschen</Button>
            <Button onClick={closeModal}><i className="fas fa-xmark" /> Abbrechen</Button>
            <Button onClick={mobileDoneHandler}><i className="fas fa-check" /> Fertig</Button>
          </div>
        </div>
      )}
    </>;
  }

  return <>
    <SignatureCanvas
      penColor='blue'
      canvasProps={{ className: styles.sigCanvas }}
      onEnd={strokeEndHandler}
      ref={sigPad}
    /><br />
    <Button onClick={clearHandler}>Feld löschen</Button>
  </>;
};

export default Signature;
